import { types } from 'mobx-state-tree';

export const ClaimModel = types.model({
    _id: types.identifier,
    createdAt: types.string,
    customer: types.string,
    giftlySuite: types.string,
    type: types.string
});
